import React, { useRef, useEffect } from 'react';
import "./ScrollingChat.css";

const ScrollingChat = ({ children }) => {

  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [children]);

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '25vh', // change this value to desired maximum height
    width: '50%',
    margin: 'auto',
    overflowY: 'auto',
    padding: '1rem',
    border: '1px solid #ccc',
    textAlign: 'left',
    borderRadius: '20px',
    marginBottom: '50px',
  };

  return (
    <div style={containerStyle} ref={containerRef}>
      {children}
    </div>
  );
};

export default ScrollingChat;
